import { orgUsers$ } from 'streams/orgUsers/orgUsers$';
import { usersOperations } from '@ardoq/core';

/**
 * Get all members of the organization including contributors.
 */
const getAllOrgUsers = () =>
  usersOperations.getAllOrgUsers(orgUsers$.state.users);

const getUserById = (userId: string) =>
  usersOperations.getUserById(orgUsers$.state.byId, userId);

/**
 * `orgUsersInterface` snapshots `orgUsers$.state` at call time.
 *
 * The app is stream-based now. Join `orgUsers$`
 * (`streams/orgUsers/orgUsers$.ts`) at a permitted boundary -- a `*$.ts` file, a
 * file inside a `*$/` folder, or a `*routines.ts` -- and pass the resolved users
 * to `usersOperations` (`@ardoq/core`), which these members already delegate to.
 *
 * Every member below is deprecated. See
 * `packages/eslint-plugin-ardoq-lint/docs/rules/no-model-interface-call.md`
 * for the hoisting recipe.
 */
export const orgUsersInterface = {
  /**
   * Get all members of the organization including contributors.
   *
   * @deprecated Join `orgUsers$` and call `usersOperations.getAllOrgUsers(users)` (`@ardoq/core`) with the resolved state.
   */
  getAllOrgUsers,
  /**
   * @deprecated Join `orgUsers$` and call `usersOperations.getUserById(byId, userId)` (`@ardoq/core`) with the resolved map.
   */
  getUserById,
};
